var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { openBlock, createElementBlock, createElementVNode, createBlock, resolveDynamicComponent, normalizeStyle, defineComponent, useSlots, useAttrs, renderSlot, h, computed, unref, mergeProps, withCtx, createCommentVNode, createVNode, resolveComponent, createTextVNode, toDisplayString, Fragment, renderList, normalizeClass, ref } from "vue";
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$r = {};
const _hoisted_1$m = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
};
const _hoisted_2$l = /* @__PURE__ */ createElementVNode("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1);
const _hoisted_3$k = /* @__PURE__ */ createElementVNode("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" }, null, -1);
const _hoisted_4$d = [
  _hoisted_2$l,
  _hoisted_3$k
];
function _sfc_render$k(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$m, _hoisted_4$d);
}
var ChevronLeftIcon = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$k]]);
const _sfc_main$q = {};
const _hoisted_1$l = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
};
const _hoisted_2$k = /* @__PURE__ */ createElementVNode("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1);
const _hoisted_3$j = /* @__PURE__ */ createElementVNode("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" }, null, -1);
const _hoisted_4$c = [
  _hoisted_2$k,
  _hoisted_3$j
];
function _sfc_render$j(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$l, _hoisted_4$c);
}
var ChevronRightIcon = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$j]]);
const _sfc_main$p = {};
const _hoisted_1$k = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
};
const _hoisted_2$j = /* @__PURE__ */ createElementVNode("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1);
const _hoisted_3$i = /* @__PURE__ */ createElementVNode("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }, null, -1);
const _hoisted_4$b = [
  _hoisted_2$j,
  _hoisted_3$i
];
function _sfc_render$i(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$k, _hoisted_4$b);
}
var ClearIcon = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$i]]);
const _sfc_main$o = {};
const _hoisted_1$j = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
};
const _hoisted_2$i = /* @__PURE__ */ createElementVNode("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1);
const _hoisted_3$h = /* @__PURE__ */ createElementVNode("path", { d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" }, null, -1);
const _hoisted_4$a = [
  _hoisted_2$i,
  _hoisted_3$h
];
function _sfc_render$h(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$j, _hoisted_4$a);
}
var DeleteIcon = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$h]]);
const _sfc_main$n = {};
const _hoisted_1$i = {
  xmlns: "http://www.w3.org/2000/svg",
  "enable-background": "new 0 0 24 24",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
};
const _hoisted_2$h = /* @__PURE__ */ createElementVNode("g", null, [
  /* @__PURE__ */ createElementVNode("rect", {
    fill: "none",
    height: "24",
    width: "24"
  })
], -1);
const _hoisted_3$g = /* @__PURE__ */ createElementVNode("g", null, [
  /* @__PURE__ */ createElementVNode("path", { d: "M5,20h14v-2H5V20z M19,9h-4V3H9v6H5l7,7L19,9z" })
], -1);
const _hoisted_4$9 = [
  _hoisted_2$h,
  _hoisted_3$g
];
function _sfc_render$g(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$i, _hoisted_4$9);
}
var DownloadIcon = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$g]]);
const _sfc_main$m = {};
const _hoisted_1$h = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2$g = /* @__PURE__ */ createElementVNode("path", { d: "M12 15 7 10H17Z" }, null, -1);
const _hoisted_3$f = [
  _hoisted_2$g
];
function _sfc_render$f(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$h, _hoisted_3$f);
}
var DropDown = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$f]]);
const _sfc_main$l = {};
const _hoisted_1$g = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2$f = /* @__PURE__ */ createElementVNode("path", { d: "M7 14 12 9 17 14Z" }, null, -1);
const _hoisted_3$e = [
  _hoisted_2$f
];
function _sfc_render$e(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$g, _hoisted_3$e);
}
var DropUp = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$e]]);
const _sfc_main$k = {};
const _hoisted_1$f = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2$e = /* @__PURE__ */ createElementVNode("path", { d: "M12 22Q9.925 22 8.1 21.212Q6.275 20.425 4.925 19.075Q3.575 17.725 2.788 15.9Q2 14.075 2 12Q2 9.925 2.788 8.1Q3.575 6.275 4.925 4.925Q6.275 3.575 8.1 2.787Q9.925 2 12 2Q14.075 2 15.9 2.787Q17.725 3.575 19.075 4.925Q20.425 6.275 21.212 8.1Q22 9.925 22 12Q22 14.075 21.212 15.9Q20.425 17.725 19.075 19.075Q17.725 20.425 15.9 21.212Q14.075 22 12 22ZM11 13H13V7H11ZM12 17Q12.425 17 12.713 16.712Q13 16.425 13 16Q13 15.575 12.713 15.287Q12.425 15 12 15Q11.575 15 11.288 15.287Q11 15.575 11 16Q11 16.425 11.288 16.712Q11.575 17 12 17Z" }, null, -1);
const _hoisted_3$d = [
  _hoisted_2$e
];
function _sfc_render$d(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$f, _hoisted_3$d);
}
var ErrorIcon = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$d]]);
const _sfc_main$j = {};
const _hoisted_1$e = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
};
const _hoisted_2$d = /* @__PURE__ */ createElementVNode("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1);
const _hoisted_3$c = /* @__PURE__ */ createElementVNode("path", { d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" }, null, -1);
const _hoisted_4$8 = [
  _hoisted_2$d,
  _hoisted_3$c
];
function _sfc_render$c(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$e, _hoisted_4$8);
}
var ExpandLessIcon = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$c]]);
const _sfc_main$i = {};
const _hoisted_1$d = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
};
const _hoisted_2$c = /* @__PURE__ */ createElementVNode("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1);
const _hoisted_3$b = /* @__PURE__ */ createElementVNode("path", { d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" }, null, -1);
const _hoisted_4$7 = [
  _hoisted_2$c,
  _hoisted_3$b
];
function _sfc_render$b(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$d, _hoisted_4$7);
}
var ExpandMoreIcon = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$b]]);
const _sfc_main$h = {};
const _hoisted_1$c = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
};
const _hoisted_2$b = /* @__PURE__ */ createElementVNode("path", { d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" }, null, -1);
const _hoisted_3$a = /* @__PURE__ */ createElementVNode("path", {
  d: "M24 24H0V0h24v24z",
  fill: "none"
}, null, -1);
const _hoisted_4$6 = [
  _hoisted_2$b,
  _hoisted_3$a
];
function _sfc_render$a(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$c, _hoisted_4$6);
}
var FirstPageIcon = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$a]]);
const _sfc_main$g = {};
const _hoisted_1$b = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2$a = /* @__PURE__ */ createElementVNode("path", { d: "M12 22Q9.925 22 8.1 21.212Q6.275 20.425 4.925 19.075Q3.575 17.725 2.788 15.9Q2 14.075 2 12Q2 9.925 2.788 8.1Q3.575 6.275 4.925 4.925Q6.275 3.575 8.1 2.787Q9.925 2 12 2Q14.075 2 15.9 2.787Q17.725 3.575 19.075 4.925Q20.425 6.275 21.212 8.1Q22 9.925 22 12Q22 14.075 21.212 15.9Q20.425 17.725 19.075 19.075Q17.725 20.425 15.9 21.212Q14.075 22 12 22ZM12 9Q12.425 9 12.713 8.712Q13 8.425 13 8Q13 7.575 12.713 7.287Q12.425 7 12 7Q11.575 7 11.288 7.287Q11 7.575 11 8Q11 8.425 11.288 8.712Q11.575 9 12 9ZM11 17H13V11H11Z" }, null, -1);
const _hoisted_3$9 = [
  _hoisted_2$a
];
function _sfc_render$9(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$b, _hoisted_3$9);
}
var InfoIcon = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$9]]);
const _sfc_main$f = {};
const _hoisted_1$a = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
};
const _hoisted_2$9 = /* @__PURE__ */ createElementVNode("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}, null, -1);
const _hoisted_3$8 = /* @__PURE__ */ createElementVNode("path", { d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" }, null, -1);
const _hoisted_4$5 = [
  _hoisted_2$9,
  _hoisted_3$8
];
function _sfc_render$8(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$a, _hoisted_4$5);
}
var LastPageIcon = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$8]]);
const _sfc_main$e = {};
const _hoisted_1$9 = {
  class: "motion-safe:tw-animate-spin",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "presentation"
};
const _hoisted_2$8 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.5",
  d: "M12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$7 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M19.0049 4.85563C18.1202 3.9883 17.0852 3.29876 15.9 2.787C14.6833 2.26233 13.3833 2 12 2C10.6167 2 9.31667 2.26233 8.1 2.787C6.94469 3.28584 5.93215 3.9536 5.06237 4.79027L6.4625 6.1904C7.98645 4.73013 9.83228 4 12 4C14.1998 4 16.0681 4.75189 17.6049 6.25566L19.0049 4.85563Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_4$4 = [
  _hoisted_2$8,
  _hoisted_3$7
];
function _sfc_render$7(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$9, _hoisted_4$4);
}
var LoadingIcon = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$7]]);
const _sfc_main$d = {};
const _hoisted_1$8 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
};
const _hoisted_2$7 = /* @__PURE__ */ createElementVNode("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1);
const _hoisted_3$6 = /* @__PURE__ */ createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" }, null, -1);
const _hoisted_4$3 = [
  _hoisted_2$7,
  _hoisted_3$6
];
function _sfc_render$6(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$8, _hoisted_4$3);
}
var RemoveCircleIcon = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$6]]);
const _sfc_main$c = {};
const _hoisted_1$7 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
};
const _hoisted_2$6 = /* @__PURE__ */ createElementVNode("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1);
const _hoisted_3$5 = /* @__PURE__ */ createElementVNode("path", { d: "M19 13H5v-2h14v2z" }, null, -1);
const _hoisted_4$2 = [
  _hoisted_2$6,
  _hoisted_3$5
];
function _sfc_render$5(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$7, _hoisted_4$2);
}
var RemoveIcon = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$5]]);
const _sfc_main$b = {};
const _hoisted_1$6 = {
  xmlns: "http://www.w3.org/2000/svg",
  "enable-background": "new 0 0 24 24",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
};
const _hoisted_2$5 = /* @__PURE__ */ createElementVNode("g", null, [
  /* @__PURE__ */ createElementVNode("path", {
    d: "M0,0h24v24H0V0z",
    fill: "none"
  }),
  /* @__PURE__ */ createElementVNode("path", { d: "M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z" })
], -1);
const _hoisted_3$4 = [
  _hoisted_2$5
];
function _sfc_render$4(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$6, _hoisted_3$4);
}
var SettingsIcon = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$4]]);
const _sfc_main$a = {};
const _hoisted_1$5 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2$4 = /* @__PURE__ */ createElementVNode("path", { d: "M8.95 9.05 7.5 7.6 12 3.1 16.5 7.6 15.05 9.05 12 6ZM12 21 7.5 16.5 8.95 15.05 12 18.1 15.05 15.05 16.5 16.5Z" }, null, -1);
const _hoisted_3$3 = [
  _hoisted_2$4
];
function _sfc_render$3(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$5, _hoisted_3$3);
}
var UnfoldMore = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$3]]);
const _sfc_main$9 = {};
const _hoisted_1$4 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2$3 = /* @__PURE__ */ createElementVNode("path", { d: "M1 21 12 2 23 21ZM11 15H13V10H11ZM12 18Q12.425 18 12.713 17.712Q13 17.425 13 17Q13 16.575 12.713 16.288Q12.425 16 12 16Q11.575 16 11.288 16.288Q11 16.575 11 17Q11 17.425 11.288 17.712Q11.575 18 12 18Z" }, null, -1);
const _hoisted_3$2 = [
  _hoisted_2$3
];
function _sfc_render$2(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$4, _hoisted_3$2);
}
var WarningIcon = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$2]]);
const iconMap = {
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  clear: ClearIcon,
  close: ClearIcon,
  delete: DeleteIcon,
  download: DownloadIcon,
  dropDown: DropDown,
  dropUp: DropUp,
  error: ErrorIcon,
  expandLess: ExpandLessIcon,
  expandMore: ExpandMoreIcon,
  firstPage: FirstPageIcon,
  info: InfoIcon,
  lastPage: LastPageIcon,
  loading: LoadingIcon,
  remove: RemoveIcon,
  removeCircle: RemoveCircleIcon,
  settings: SettingsIcon,
  unfoldMore: UnfoldMore,
  warning: WarningIcon
};
const iconNames = Object.keys(iconMap);
const _sfc_main$8 = {
  name: "SvIcon",
  props: {
    color: {
      type: String,
      default: null
    },
    relativeSized: {
      type: Boolean,
      default: true
    },
    size: {
      type: Number,
      default: 1.5
    },
    icon: {
      type: String,
      required: true,
      validator(value) {
        return iconNames.indexOf(value) !== -1;
      }
    }
  },
  computed: {
    component() {
      return iconMap[this.icon];
    },
    unit() {
      return this.relativeSized ? "em" : "rem";
    },
    sizeWithUnit() {
      return this.size + this.unit;
    },
    style() {
      return {
        verticalAlign: "top",
        color: this.color,
        width: this.sizeWithUnit,
        height: this.sizeWithUnit
      };
    }
  }
};
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent($options.component), {
    style: normalizeStyle($options.style)
  }, null, 8, ["style"]);
}
var SvIcon = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$1]]);
const __default__$2 = {
  inheritAttrs: false
};
const _sfc_main$7 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$2), {
  props: {
    wrapIs: { default: "div" },
    wrap: { type: Boolean }
  },
  setup(__props) {
    const slots = useSlots();
    const attrs = useAttrs();
    const render = () => h(__props.wrapIs, attrs, slots);
    return (_ctx, _cache) => {
      return __props.wrap ? (openBlock(), createBlock(render, { key: 0 })) : renderSlot(_ctx.$slots, "default", { key: 1 });
    };
  }
}));
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  props: {
    variant: { default: "default" },
    fullWidth: { type: Boolean, default: false },
    hideLabel: { type: Boolean, default: false },
    radius: { default: "default" },
    startIcon: null,
    endIcon: null,
    textAlign: { default: "center" },
    to: null
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const slots = useSlots();
    const variantClasses = computed(() => {
      return {
        default: [
          "tw-text-gray-900",
          "tw-border",
          "tw-border-gray-200",
          "hover:tw-border-gray-300",
          "hover:tw-bg-gray-50",
          "hover:tw-text-gray-900"
        ],
        filled: [
          "tw-bg-primary-700",
          "tw-text-white",
          "tw-border",
          "tw-border-primary-700",
          "hover:tw-bg-primary-800",
          "hover:tw-border-primary-800",
          "hover:tw-text-white"
        ],
        subdued: [
          "tw-bg-white",
          "tw-text-primary-700",
          "tw-border",
          "tw-border-white",
          "hover:tw-bg-primary-50",
          "hover:tw-border-primary-50",
          "hover:tw-text-primary-700"
        ],
        light: [
          "tw-bg-primary-50",
          "tw-text-primary-700",
          "tw-border",
          "tw-border-primary-50",
          "hover:tw-bg-primary-100",
          "hover:tw-border-primary-100",
          "hover:tw-text-primary-700"
        ]
      }[__props.variant];
    });
    const hasStartIcon = computed(() => {
      return slots.startIcon || __props.startIcon || (slots.endIcon || __props.endIcon) && __props.hideLabel;
    });
    const hasEndIcon = computed(() => {
      return slots.endIcon || __props.endIcon || (slots.startIcon || __props.startIcon) && __props.hideLabel;
    });
    const paddingClasses = computed(() => {
      if (hasStartIcon.value && hasEndIcon.value) {
        return [__props.hideLabel ? "tw-px-2" : "tw-px-3"];
      }
      if (hasStartIcon.value) {
        return ["tw-pl-3", __props.radius === "default" ? "tw-pr-6" : "tw-pr-4"];
      }
      if (hasEndIcon.value) {
        return [__props.radius === "default" ? "tw-pl-6" : "tw-pl-4", "tw-pr-3"];
      }
      return [__props.radius === "default" ? "tw-px-6" : "tw-px-4"];
    });
    const radiusClass = computed(() => {
      return {
        none: "tw-rounded-none",
        sm: "tw-rounded-sm",
        default: "tw-rounded"
      }[__props.radius];
    });
    const alignClass = computed(() => {
      return {
        left: "tw-justify-start tw-text-left",
        right: "tw-justify-end tw-text-right",
        center: "tw-justify-center tw-text-center"
      }[__props.textAlign];
    });
    const classes = computed(() => {
      return [
        ...variantClasses.value,
        ...paddingClasses.value,
        radiusClass.value,
        alignClass.value
      ].join(" ");
    });
    const tag = computed(() => __props.to !== void 0 && __props.to !== null ? "router-link" : "button");
    const toAttrs = computed(() => tag.value === "router-link" ? {
      to: __props.to
    } : {});
    const onClick = (e) => {
      if (tag.value !== "button")
        return;
      emit("click", e);
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(tag)), mergeProps({
        class: ["tw tw-cursor-pointer tw-py-2 tw-inline-flex tw-gap-2 tw-items-center focus-visible:tw-outline-none focus-visible:tw-ring focus-visible:tw-ring-offset-2 focus-visible:tw-ring-gray-800 active:tw-translate-y-px tw-align-middle", { [unref(classes)]: true, "tw-w-full": __props.fullWidth }]
      }, unref(toAttrs), { onClick }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "startIcon", {}, () => [
            __props.startIcon ? (openBlock(), createBlock(SvIcon, {
              key: 0,
              icon: __props.startIcon
            }, null, 8, ["icon"])) : createCommentVNode("", true)
          ]),
          createVNode(_sfc_main$7, {
            wrapIs: "span",
            wrap: __props.hideLabel,
            class: "tw-sr-only"
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["wrap"]),
          renderSlot(_ctx.$slots, "endIcon", {}, () => [
            __props.endIcon ? (openBlock(), createBlock(SvIcon, {
              key: 0,
              icon: __props.endIcon
            }, null, 8, ["icon"])) : createCommentVNode("", true)
          ])
        ]),
        _: 3
      }, 16, ["class"]);
    };
  }
});
var SvNavigationListButton = defineComponent({
  name: "SvNavigationListButton",
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 8
    }
  },
  data() {
    return {
      showHidden: false
    };
  },
  computed: {
    childNodes() {
      var _a, _b, _c;
      return (_c = (_b = (_a = this.$slots).default) == null ? void 0 : _b.call(_a)) != null ? _c : [];
    },
    limitedChildNodes() {
      if (this.childNodes.length > this.limit + 2) {
        return this.childNodes.slice(0, this.limit);
      }
      return this.childNodes;
    },
    numberHidden() {
      return this.childNodes.length - this.limitedChildNodes.length;
    }
  },
  render() {
    return createVNode("li", {
      "class": "tw tw-flex tw-flex-col tw-gap-2"
    }, [createVNode(_sfc_main$6, mergeProps({
      "radius": "sm",
      "variant": this.active ? "filled" : "subdued",
      "textAlign": "left"
    }, this.$attrs), {
      default: () => [this.label]
    }), this.active ? createVNode("div", {
      "class": "tw-flex tw-flex-col tw-border-l-4 tw-gap-1 tw-pl-2 tw-ml-4 tw-border-primary-700"
    }, [this.childNodes ? createVNode("ul", {
      "class": "tw-flex tw-flex-col tw-gap-1"
    }, [this.showHidden ? this.childNodes : this.limitedChildNodes]) : null, this.numberHidden > 0 ? createVNode(_sfc_main$6, {
      "radius": "sm",
      "textAlign": "left",
      "onClick": () => this.showHidden = !this.showHidden,
      "startIcon": this.showHidden ? "expandLess" : "expandMore"
    }, {
      default: () => [this.showHidden ? `Hide ${this.numberHidden} items` : `Show ${this.numberHidden} more`]
    }) : null]) : null]);
  }
});
const _sfc_main$5 = {
  name: "SvNavigationList",
  components: { SvNavigationListButton, SvButton: _sfc_main$6, SvIcon },
  props: {
    parent: {
      type: Object,
      required: false
    },
    items: {
      type: Array,
      required: true
    }
  }
};
const _hoisted_1$3 = { class: "tw tw-flex tw-flex-col tw-gap-4" };
const _hoisted_2$2 = { class: "tw-flex tw-flex-col tw-gap-2" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SvButton = resolveComponent("SvButton");
  const _component_sv_navigation_list_button = resolveComponent("sv-navigation-list-button");
  return openBlock(), createElementBlock("div", _hoisted_1$3, [
    $props.parent ? (openBlock(), createBlock(_component_SvButton, {
      key: 0,
      to: $props.parent.to,
      startIcon: "chevronLeft",
      icon: "start",
      radius: "sm",
      textAlign: "left"
    }, {
      default: withCtx(() => [
        createTextVNode(" Back to " + toDisplayString($props.parent.name), 1)
      ]),
      _: 1
    }, 8, ["to"])) : createCommentVNode("", true),
    createElementVNode("ul", _hoisted_2$2, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.items, (item) => {
        return openBlock(), createBlock(_component_sv_navigation_list_button, {
          key: item.name,
          label: item.name,
          active: item.active,
          to: item.to
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(item.children, (child) => {
              return openBlock(), createBlock(_component_sv_navigation_list_button, {
                key: child.name,
                label: child.name,
                to: child.to
              }, null, 8, ["label", "to"]);
            }), 128))
          ]),
          _: 2
        }, 1032, ["label", "active", "to"]);
      }), 128))
    ])
  ]);
}
var NavigationList = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render]]);
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  props: {
    loading: { type: Boolean, default: true },
    animate: { type: Boolean, default: true },
    height: { default: "block" },
    width: { default: "full" },
    radius: { default: "default" }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const radiusClass = computed(() => ({
      none: "",
      sm: "tw-rounded-sm",
      default: "tw-rounded",
      lg: "tw-rounded-lg",
      full: "tw-rounded-full"
    })[props.radius]);
    const heightClass = computed(() => typeof props.height === "string" ? {
      text: "tw-h-4",
      block: "tw-h-standard"
    }[props.height] : null);
    const widthClass = computed(() => typeof props.height === "string" ? {
      full: "tw-w-full",
      "1/4": "tw-w-1/4",
      "1/2": "tw-w-1/2",
      "3/4": "tw-w-3/4"
    }[props.width] : null);
    const style = computed(() => ({
      height: typeof props.height === "number" ? props.height + "px" : null,
      width: typeof props.width === "number" ? props.width + "px" : null
    }));
    return (_ctx, _cache) => {
      return __props.loading ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["tw tw-relative tw-inline-block", unref(slots).default ? [
          __props.animate ? "tw-animate-pulse" : null
        ] : [
          unref(heightClass),
          unref(widthClass),
          __props.animate ? "tw-animate-pulse" : null
        ]]),
        style: normalizeStyle(unref(style))
      }, [
        renderSlot(_ctx.$slots, "default"),
        createElementVNode("span", {
          class: normalizeClass(["tw-block tw-absolute tw-inset-0 tw-bg-gray-100", { [unref(radiusClass)]: true }]),
          "aria-hidden": "true"
        }, null, 2)
      ], 6)) : renderSlot(_ctx.$slots, "default", { key: 1 });
    };
  }
});
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  props: {
    is: null,
    elevated: { type: Boolean, default: false },
    customPadding: { type: Boolean, default: false },
    col: { type: Boolean, default: true }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createBlock(resolveDynamicComponent((_a = __props.is) != null ? _a : "div"), {
        class: normalizeClass(["tw tw-overflow-hidden tw-bg-white tw-shadow tw-rounded tw-border tw-border-gray-50 tw-flex", {
          "tw-flex-col": __props.col,
          "tw-p-4": !__props.customPadding,
          "tw-shadow": !__props.elevated,
          "tw-shadow-lg": __props.elevated
        }])
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _hoisted_1$2 = { class: "tw-mr-3" };
const _hoisted_2$1 = { class: "tw-font-semibold" };
const _hoisted_3$1 = { class: "tw-justify-self-end tw-flex-0" };
const _hoisted_4$1 = /* @__PURE__ */ createTextVNode("Close");
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  props: {
    title: null,
    icon: null,
    dismissable: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$3, {
        elevated: "",
        col: false,
        class: "tw-items-center tw-gap-4 tw-px-5"
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "icon", {}, () => [
            createVNode(SvIcon, {
              icon: __props.icon,
              size: 2
            }, null, 8, ["icon"])
          ]),
          createElementVNode("div", _hoisted_1$2, [
            createElementVNode("div", _hoisted_2$1, toDisplayString(__props.title), 1),
            renderSlot(_ctx.$slots, "default")
          ]),
          createElementVNode("div", _hoisted_3$1, [
            renderSlot(_ctx.$slots, "action", {}, () => [
              __props.dismissable ? (openBlock(), createBlock(_sfc_main$6, {
                key: 0,
                variant: "subdued",
                startIcon: "close",
                hideLabel: "",
                onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("dismissed"))
              }, {
                default: withCtx(() => [
                  _hoisted_4$1
                ]),
                _: 1
              })) : createCommentVNode("", true)
            ])
          ])
        ]),
        _: 3
      });
    };
  }
});
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate(uuid) {
  return typeof uuid === "string" && REGEX.test(uuid);
}
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).substr(1));
}
function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
  if (!validate(uuid)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid;
}
function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return stringify(rnds);
}
const _hoisted_1$1 = ["aria-labelledby", "aria-describedby"];
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-gap-1.5" };
const _hoisted_3 = ["id"];
const _hoisted_4 = ["id"];
const __default__$1 = {
  inheritAttrs: false
};
const _sfc_main$1 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$1), {
  props: {
    icon: null,
    title: null,
    color: { default: "blue" }
  },
  setup(__props) {
    const id = ref(v4());
    const colorClasses = computed(() => {
      return {
        gray: ["tw-bg-gray-50", "tw-text-gray-900"],
        dark: ["tw-bg-gray-900", "tw-text-gray-50"],
        red: ["tw-bg-red-50", "tw-text-gray-800"],
        orange: ["tw-bg-orange-50", "tw-text-gray-800"],
        blue: ["tw-bg-light-blue-50", "tw-text-gray-800"]
      }[__props.color];
    });
    const iconClasses = computed(() => ({
      gray: ["tw-text-gray-600"],
      dark: ["tw-text-gray-300"],
      red: ["tw-text-red-700"],
      orange: ["tw-text-orange-700"],
      blue: ["tw-text-light-blue-700"]
    })[__props.color]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["tw-flex tw-rounded tw-gap-6 tw-py-6 tw-px-8 tw-items-center", unref(colorClasses)]),
        role: "alert",
        "aria-labelledby": id.value + "-title",
        "aria-describedby": id.value + "-desc"
      }, [
        __props.icon ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(iconClasses))
        }, [
          renderSlot(_ctx.$slots, "icon", {}, () => [
            __props.icon ? (openBlock(), createBlock(SvIcon, {
              key: 0,
              size: 3,
              icon: __props.icon
            }, null, 8, ["icon"])) : createCommentVNode("", true)
          ])
        ], 2)) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_2, [
          __props.title ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "tw-font-semibold",
            id: id.value + "-title"
          }, toDisplayString(__props.title), 9, _hoisted_3)) : createCommentVNode("", true),
          createElementVNode("div", {
            id: id.value + "-desc"
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 8, _hoisted_4)
        ])
      ], 10, _hoisted_1$1);
    };
  }
}));
const _hoisted_1 = { class: "tw-px-2.5" };
const __default__ = {
  inheritAttrs: false
};
const _sfc_main = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__), {
  props: {
    color: { default: "blue" },
    addonText: null,
    fullWidth: { type: Boolean, default: false }
  },
  setup(__props) {
    const colorClasses = computed(() => {
      return {
        gray: ["tw-bg-gray-100", "tw-text-gray-900"],
        dark: ["tw-bg-gray-900", "tw-text-white"],
        red: ["tw-bg-red-200", "tw-text-gray-900"],
        orange: ["tw-bg-orange-200", "tw-text-gray-900"],
        blue: ["tw-bg-light-blue-200", "tw-text-gray-900"]
      }[__props.color];
    });
    const addonClasses = computed(() => ({
      gray: ["tw-bg-gray-200"],
      dark: ["tw-bg-gray-600"],
      red: ["tw-bg-red-300"],
      orange: ["tw-bg-orange-300"],
      blue: ["tw-bg-light-blue-300"]
    })[__props.color]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["tw-inline-flex tw-rounded tw-py-px tw-text-sm tw-justify-between", { [unref(colorClasses).join(" ")]: true, "tw-w-full": __props.fullWidth }])
      }, [
        createElementVNode("span", _hoisted_1, [
          renderSlot(_ctx.$slots, "default")
        ]),
        __props.addonText ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass(["tw-pl-2 tw-pr-2.5 tw-rounded-r", unref(addonClasses)])
        }, toDisplayString(__props.addonText), 3)) : createCommentVNode("", true)
      ], 2);
    };
  }
}));
var components = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SvIcon,
  SvButton: _sfc_main$6,
  SvNavigationList: NavigationList,
  SvNavigationListButton,
  SvSkeleton: _sfc_main$4,
  SvSurface: _sfc_main$3,
  SvNotification: _sfc_main$2,
  SvAlert: _sfc_main$1,
  SvBadge: _sfc_main
}, Symbol.toStringTag, { value: "Module" }));
var utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SvConditionalWrapper: _sfc_main$7
}, Symbol.toStringTag, { value: "Module" }));
const plugin = {
  install(Vue) {
    var _a, _b;
    for (const prop in components) {
      const component = components[prop];
      Vue.component((_a = component.name) != null ? _a : prop, component);
    }
    for (const prop in utils) {
      const util = utils[prop];
      Vue.component((_b = util.name) != null ? _b : prop, util);
    }
  }
};
export { plugin as default };
